
<script>
import Vue from 'vue';

export default {
    props: {
        nodeId: {
            default: () => 0
        }
    },
    data() {
        return {
            users: [],
            showAddModal: false,
            showChangeGrantLevelModal: false,
            currentUserId: 0,
            filterText: '',
            showChangeUserRoleModal: false
        }
    },
    computed: {
        filteredUsers() {
            if(this.$store.state.globalListFilters.includedBlindedUser) return this.users;

            return _.filter(this.users, (x) => x.Rights.GrantLevel > 0);
        },
        searchFilteredUsers() {
            if(!this.filterText) return this.filteredUsers;
            
            return _.filter(this.filteredUsers, (item) =>
            {
                return _.includes( this.$normalizeString(item.Email), this.filterText )
                    || _.includes( this.$normalizeString(item.FirstName), this.filterText )
                    || _.includes( this.$normalizeString(item.UserId+''), this.filterText )
                    || _.includes( this.$normalizeString(item.LastName), this.filterText )
                    || _.includes( this.$normalizeString(item.LastName + ' ' + item.FirstName), this.filterText )
                    || _.includes( this.$normalizeString(item.FirstName + ' ' + item.LastName), this.filterText );
            });
        }
    },
    mounted: function () {
        this.refresh();
        
        this.$root.$on('pcr_update_data', () => {
            this.refresh();
        });
    },
    methods: {
        currentChange(row) {
            if(this.$getSelectedText()) 
            {
                this.$refs['table'].setCurrentRow();
                return;
            }
            
            //a group is like an establishment for the tree selection
            this.$router.push({ query: { establishmentId: this.nodeId, userId: row.UserId } });
        },
        fullNameFormatter(row, column) {
            return row.FirstName + ' ' + row.LastName;
        },
        sortFullName(a, b) {
            var aFN = this.fullNameFormatter(a);
            var bFN = this.fullNameFormatter(b);
            return aFN.localeCompare( bFN ) > 0;
        },
        editUserRole(row) {
            this.currentUserId = row.UserId;
            this.showChangeUserRoleModal = true;
        },
        editGrantLevel(row) {
            this.currentUserId = row.UserId;
            this.showChangeGrantLevelModal = true;
        },
        renderRegistrationDateHeader() {
            return (
                <el-tooltip placement="top" content="Date de validation d'inscription par l'utilisateur" effect="light" open-delay={300}>
                    <span>Inscription <i class="fa fa-question-circle pointer" aria-hidden="true"></i></span>
                </el-tooltip>
            );
        }
    },
    watch: {
        nodeId(val) {
            if (val) {
                this.refresh();
            }
        },
        showChangeGrantLevelModal(val) {
            if(!val) {
                //reset current user on modal close
                this.currentUserId = null;
            }
        },
        showChangeUserRoleModal(val) {
            if(!val) {
                //reset current user on modal close
                this.currentUserId = null;
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/cross-components/mixins/zone-user-list.vue